
import { Loader2 } from "lucide-react";

interface LoadingStateProps {
  message?: string;
}

const LoadingState = ({ message = "Carregando..." }: LoadingStateProps) => (
  <div className="flex flex-col items-center justify-center py-12">
    <Loader2 className="h-12 w-12 animate-spin text-primary" />
    <p className="mt-4 text-gray-500">{message}</p>
  </div>
);

export default LoadingState;
